import React, { Component } from "react";
import axios from "axios";
import { Card, Grid, TextField } from "@mui/material";
import { Navigate } from "react-router-dom";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

export default class AddYoutubeSlider extends Component {
  state = {
    title: "",
    youtube_id: "",
    notification: false,
    noticolor: "success",
    message: "",
    redirect: false,
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = () => {
    if (init() !== "success") {
      this.setState({ redirect: true });
      return;
    }

    const { title, youtube_id } = this.state;

    if (!youtube_id) {
      this.setState({
        notification: true,
        noticolor: "error",
        message: "Youtube ID is required",
      });
      return;
    }

    const payload = {
      title,
      youtube_id,
    };

    axios
      .post(Constants.postUrls.createYoutubeSlider, payload)
      .then((resp) => {
        if (resp.data.status === "success") {
          this.setState({
            notification: true,
            noticolor: "success",
            message: resp.data.message,
          });

          setTimeout(() => {
            this.setState({ redirect: true });
          }, 1500);
        } else {
          this.setState({
            notification: true,
            noticolor: "error",
            message: resp.data.message,
          });
        }
      })
      .catch((err) => {
        console.log(err);

        this.setState({
          notification: true,
          noticolor: "error",
          message: err.response?.data?.message || "Something went wrong",
        });
      });
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/youtubeslider" replace />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Add Youtube Slider
              </MDTypography>
            </MDBox>

            <MDBox p={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Title (optional)"
                    name="title"
                    value={this.state.title}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    required
                    label="Youtube Video ID"
                    name="youtube_id"
                    helperText="Example: dQw4w9WgXcQ"
                    value={this.state.youtube_id}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item xs={12} align="right">
                  <MDButton variant="contained" color="info" onClick={this.handleSubmit}>
                    Save
                  </MDButton>
                </Grid>
              </Grid>
            </MDBox>
          </Card>

          <MDSnackbar
            color={this.state.noticolor}
            icon="notifications"
            title="Youtube Slider"
            content={this.state.message}
            dateTime="Just now"
            open={this.state.notification}
          />
        </MDBox>
      </DashboardLayout>
    );
  }
}
